import { Timestamp } from '@griply/types';
import { format, isSameYear } from 'date-fns';

export const getDateLabel = (date: Timestamp, today: Timestamp) => {
  const dateFormat = isSameYear(date, today) ? 'MMM d' : "MMM d, ''yy";
  return format(date, dateFormat);
};
